import styled from "@emotion/styled";

export const BrandLogo = styled.img<{ brandCode: string }>`
  height: ${({ brandCode }) => brandCode === 'generali' ? '30px' : '50px'};
  object-fit: contain;
`;